import { AutogenModelCarriers, AutogenRowCarriers } from "./autogen/AutogenModelCarriers";

export class ModelCarriers extends AutogenModelCarriers<RowCarriers> {
    constructor() {
        super(RowCarriers);
    }
}

export class RowCarriers extends AutogenRowCarriers {
}